export default "__VITE_ASSET__DnGjb7gX__"